export var animation = {
    timing: {
        slow: '300ms',
        default: '120ms',
        fast: '30ms'
    }
};
//# sourceMappingURL=animation.js.map